import { Injectable } from '@angular/core';
import { GenericHttpService } from '../generic.http.service';
import { Region } from '../../../model/api/administration/region';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class RegionHttpService extends GenericHttpService<Region, number> {
    constructor(public http: HttpClient) {
        super(http, '', 'regions');
    }
}
